@if (currentUser$ | async; as user) {
  <ng-container>
    @if (user.isAuthenticated && enableMessageInbox) {
      <div>
        <a routerLink="/mdd/message-inbox" _ngcontent-ng-c831766064>
          <i class="fas fa-envelope fa-lg"></i>
        </a>
      </div>
    }
  </ng-container>
}
